module.exports = __webpack_public_path__ + "GlitterDustTrinkets.webp?f9ac8f4c20b17d7899fbff56057e65ff";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/GlitterDustTrinkets.webp
// module id = 92
// module chunks = 0